module.exports = __webpack_public_path__ + "media/assets/home_images/banner2-5d8ff23759d23355e2121a8376245b5f.png";